export default "__VITE_ASSET__CG1j6S9E__"